import { useEffect, useState } from "react";
import { api, apiError } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import { StatusBadge } from "../../components/StatusBadge";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function PartnerProfile() {
  const [p, setP] = useState(null);
  const [form, setForm] = useState({ contact_person: "", phone: "", city: "", email: "" });

  useEffect(() => {
    api.get("/partner/me").then((r) => {
      setP(r.data);
      setForm({ contact_person: r.data.contact_person || "", phone: r.data.phone || "",
                city: r.data.city || "", email: r.data.email || "" });
    });
  }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/partner/me", form);
      setP(data);
      toast.success("Profile updated");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  if (!p) return <div className="p-8 text-muted-foreground">Loading…</div>;

  return (
    <>
      <PageHeader title="My Profile" subtitle="Manage your contact details"
        actions={<StatusBadge value={p.status} />} />
      <div className="p-8 max-w-2xl space-y-6">
        <Card className="rounded-sm border-border p-6">
          <h3 className="font-heading font-semibold mb-4">Business Details (read-only)</h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            {[["Partner Name", p.name], ["Category", p.category], ["GSTIN", p.gstin || "—"], ["Login Email", p.login_email || "—"]].map(([l, v]) => (
              <div key={l} className="border-b border-border pb-2">
                <p className="label-caps">{l}</p><p className="font-medium mt-1">{v}</p>
              </div>
            ))}
          </div>
        </Card>

        <Card className="rounded-sm border-border p-6">
          <h3 className="font-heading font-semibold mb-4">Editable Details</h3>
          <div className="space-y-4" data-testid="profile-form">
            {[["contact_person", "Contact Person"], ["phone", "Phone"], ["email", "Email"], ["city", "City"]].map(([k, l]) => (
              <div key={k}>
                <Label className="label-caps">{l}</Label>
                <Input data-testid={`profile-${k}`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="rounded-sm mt-1.5" />
              </div>
            ))}
            <Button className="rounded-sm" onClick={save} data-testid="profile-save">Save Changes</Button>
          </div>
        </Card>

        <Card className="rounded-sm border-border p-6" data-testid="partner-service-areas">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-heading font-semibold">My Service Areas (Pincodes)</h3>
            <span className="text-xs text-muted-foreground">View only · managed by Fixigo</span>
          </div>
          {(!p.service_areas || p.service_areas.length === 0) ? (
            <p className="text-sm text-muted-foreground">No pincodes assigned yet. Contact the Fixigo team to add your coverage areas.</p>
          ) : (
            <div className="space-y-4">
              {p.service_areas.map((a, i) => (
                <div key={i}>
                  <p className="label-caps mb-2">{a.city || "Other"}</p>
                  <div className="flex flex-wrap gap-1.5">
                    {(a.pincodes || []).map((pc, j) => (
                      <span key={j} className="inline-flex items-center gap-1 text-xs font-mono bg-secondary px-2 py-1 rounded-sm" data-testid={`area-pin-${pc.pincode || pc}`}>
                        {pc.pincode || pc}{pc.area ? ` · ${pc.area}` : ""}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
    </>
  );
}
